import Axios from "axios";
import React from "react";
import { Spin } from "../loading";

interface ComplaintStatisticsProps {
  date: string;
}

export const ComplaintStatistics: React.FC<ComplaintStatisticsProps> = (props) => {
  const { date } = props;

  const [loading, setLoading] = React.useState(false);
  const [data, setData] = React.useState<Record<string, string | number>>();

  const fetch = () => {
    if (!loading) {
      setLoading(true);

      Axios.get<Record<string, string | number>>(`/complaint/statistics`, {
        params: {
          date,
        },
      })
        .then((res) => {
          setData(res.data)
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  React.useEffect(() => {
    fetch();
  }, [date]);

  const statistics = [
    {
      name: 'Total nos. of complaints',
      key: 'total'
    },
    {
      name: 'Total nos. of Islands (excluding Lamma)',
      key: 'totalOfIslands'
    },
    {
      name: 'Total nos. of bollards',
      key: 'totalOfBollards'
    },
    {
      name: 'Total nos. of graffiti',
      key: 'totalOfGraffiti'
    },
    {
      name: 'Major complaint nature',
      key: 'majorComplaintNature'
    },
    {
      name: 'Major complaint district',
      key: 'majorComplaintDistrict'
    },
    {
      name: 'Total nos. of urgent cases',
      key: 'totalOfUrgent'
    },
    {
      name: 'Total nos. of non urgent cases',
      key: 'totalOfNonUrgent'
    },
  ];

  return (
    <Spin spin={loading}>
      {
        statistics.map(({ name, key }) => {
          return (
            <div style={{ display: 'table', width: '750px' }}>
              <div style={{ display: 'table-cell', width: '400px' }}>
                <span className="complaint-statistics-title">{name}</span>
              </div>

              <div style={{ display: 'table-cell', width: '50px', textAlign: 'center' }}>
                <span className="complaint-statistics-title">:</span>
              </div>

              <div style={{ display: 'table-cell', width: '300px' }}>
                <span className="complaint-statistics-title">{data?.[key]}</span>
              </div>
            </div>
          );
        })
      }
    </Spin>
  );
};
